import React, { FC } from 'react';
import { RootState, AppDispatch } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import { Lightbox } from 'sofa-reborn-react';
import { setCurrentLightbox } from '../store/application/actions';
import NoValidLink from '../components/NoValidLink/NoValidLink';

const NoValidLinkContainer: FC = () => {
	const currentLightbox = useSelector<RootState, Lightbox>(
		(state) => state.application.currentLightbox
	);

	const dispatch = useDispatch<AppDispatch>();

	return (
		<NoValidLink
			showPrompt={currentLightbox === 'no-valid-link'}
			onClick={() => {
				dispatch(setCurrentLightbox('none'));
				window.location.assign('https://www.ikea.com/');
			}}
		></NoValidLink>
	);
};
export default NoValidLinkContainer;
